// 图表相关通用翻译
export default {
  // 系列名称
  inflow: "转入",
  outflow: "转出",

  // Y轴单位
  unitTimes: "单位:(次)",
};
